module.exports = __webpack_public_path__ + "img/weddings_10_V.1c871dd6.webp";